<template>
	<v-app>
		<NavView>
		</NavView>
		<v-main>
			<v-card>
				<v-tabs v-model="activeTab">
					<v-tab @click="getOrder()">
						订单
					</v-tab>
					<v-tab @click="getDelivers()">
						送货记录
					</v-tab>
					<v-tab @click="getReconciliationsSaved()">
						对账记录
					</v-tab>
					<v-tab @click="getInvicesByVender()">
						发票记录
					</v-tab>
				</v-tabs>

				<v-tabs-items v-model="activeTab">
					<v-tab-item>
						<v-card>
							<v-container>
								<v-row align="center">
									<v-col cols="4" sm="4" md="2" lg="1">
										<v-select v-model="searchParms.year" :items="[2024,2025,2026,2027]" label="年份"
											chips clearable></v-select>
									</v-col>
									<v-col cols="4" sm="4" md="2" lg="1">
										<v-select v-model="searchParms.month" :items="[1,2,3,4,5,6,7,8,9,10,11,12]"
											label="月份" chips clearable></v-select>
									</v-col>
									<v-col cols="4" sm="4" md="2" lg="1">
										<v-btn @click="search">查询</v-btn>
									</v-col>
								</v-row>
								<v-row>
									<v-col cols="12">
										<span class="action-bar">
											<v-btn @click="print()">合同</v-btn>
											<v-btn @click="showDetail()">详情</v-btn>
											<v-btn @click="deliverDialogOpen()">送货</v-btn>
											<v-btn @click="reconciliation()">对账</v-btn>
										</span>
									</v-col>
								</v-row>
							</v-container>

							<v-data-table :headers="orderHeaders" :items="orders" item-key="pucOrderId"
								:items-per-page="10" v-model="selected" show-select >
								<template slot="item.state" slot-scope="{ item }">
									<span v-if="item.state=='YDH'">是</span>
									<span v-if="item.state=='BFYDH'">部分已到</span>
								</template>
							</v-data-table>
						</v-card>
					</v-tab-item>
					<v-tab-item>
						<v-card>
							<v-container>
								<v-row justify="center">
									<span class="action-bar"><v-btn
											@click="delDeliverIndeliversByUserId()">删除</v-btn><v-btn
											@click="printDeliver()">打印送货单</v-btn></span>
								</v-row>
							</v-container>
							<v-data-table v-model="selectedDeliversByUserId" :headers="deliversByUserIdHeaders"
								:items="deliversByUserId" :items-per-page="5" item-key="deliverId"
								show-select></v-data-table>
						</v-card>
					</v-tab-item>
					<v-tab-item>
						<v-card>
							<v-container>
								<v-row justify="center">
									<span class="action-bar"><v-btn @click="deleteReconciliation()">删除</v-btn><v-btn
											@click="printReconciliation()">打印对账单</v-btn><v-btn
											@click="addInvoice()">登记发票</v-btn></span>
								</v-row>
							</v-container>
							<v-data-table v-model="selectedReconciliationSaved" :headers="reconciliationsSavedHeader"
								:items="reconciliationsSaved" :items-per-page="5" item-key="reconcilationId" show-select>
								<template slot="item.sure" slot-scope="{ item }">
									<span v-if="item.sure==1">已确认</span>
									<span v-if="item.sure==0">未确认</span>
								</template>
							</v-data-table>
						</v-card>
					</v-tab-item>

					<v-tab-item>
						<v-card>
							<v-container>
								<v-row justify="center">
									<span class="action-bar"><v-btn @click="deleteInvoice">删除</v-btn></span>
								</v-row>
							</v-container>
							<v-data-table show-select v-model="selectedInvoice" :items="invoices" item-key="invoiceId"
								:headers="invoicesHeader">
								<template slot="item.fileId" slot-scope="{ item }">
									<v-icon @click="getInvoiceFile(item.fileId)">mdi-file</v-icon>
								</template>
							</v-data-table>
						</v-card>
					</v-tab-item>

				</v-tabs-items>
			</v-card>
			<v-dialog v-model="detailDialog" :fullscreen="$vuetify.breakpoint.xsOnly">
				<v-data-table :items="details" :headers="detailHeaders" :items-per-page="5">
					<template slot="item.drawing" slot-scope="{ item }">
						<a v-if="item.drawing && item.drawing!='null'" href="javascript:void(0)"
							@click="viewDrawing(item)">查看</a>
					</template>
				</v-data-table>
			</v-dialog>

			<v-dialog v-model="showImage" max-width="90vw">
				<v-card>
					<v-card-title class="text-h5">图纸
						<v-spacer></v-spacer>
						<v-icon @click="closeImage()">mdi-close</v-icon>
					</v-card-title>
					<v-card-text class="text-center">
						<img v-if="imageUrl" :src="imageUrl" style="max-width:100%;max-height:70vh;" />
						<div v-else-if="showPdf">
							<div v-if="pdfLoading" style="color:chocolate;padding:20px;">PDF 加载中…</div>
							<div v-else-if="pdfTotalPages>0" class="pdf-toolbar">
								<v-btn small icon @click="pdfPrevPage()" :disabled="pdfPageNum<=1">
									<v-icon>mdi-chevron-left</v-icon>
								</v-btn>
								<span style="margin:0 6px;">{{pdfPageNum}} / {{pdfTotalPages}}</span>
								<v-btn small icon @click="pdfNextPage()" :disabled="pdfPageNum>=pdfTotalPages">
									<v-icon>mdi-chevron-right</v-icon>
								</v-btn>
								<v-divider vertical class="mx-2"></v-divider>
								<v-btn small icon @click="pdfZoomOut()">
									<v-icon>mdi-magnify-minus</v-icon>
								</v-btn>
								<span style="margin:0 6px;">{{Math.round(pdfScale*100)}}%</span>
								<v-btn small icon @click="pdfZoomIn()">
									<v-icon>mdi-magnify-plus</v-icon>
								</v-btn>
							</div>
							<div ref="pdfScroll" style="overflow:auto;max-height:65vh;text-align:center;background:#525659;">
								<canvas ref="pdfCanvas"></canvas>
							</div>
						</div>
						<div v-else-if="imgMsg" style="color:chocolate;">{{imgMsg}}</div>
					</v-card-text>
				</v-card>
			</v-dialog>

			<v-dialog v-model="msgDialog" max-width="500px">
				<v-card>
					<v-card-title class="text-h5">提示</v-card-title>
					<v-card-text>
						{{msg}}
					</v-card-text>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn color="blue-darken-1" variant="text" @click="msgDialog=false;msg=null;">关闭</v-btn>
						<v-spacer></v-spacer>
					</v-card-actions>
				</v-card>
			</v-dialog>

			<v-dialog v-model="deliverDialogShow" :fullscreen="$vuetify.breakpoint.xsOnly">
				<v-card>
					<v-card-title class="text-h5">送货</v-card-title>
					<v-card-text>
						<v-data-table :headers="deliverHeaders" :items="delivers" item-key="sn" :items-per-page="15" v-model="deliverSelected">
							<template slot="item.sn" slot-scope="{ item }">
								<v-text-field v-model="item.sn" dense hide-details autofocus>
								</v-text-field>
							</template>

							<template slot="item.prodName" slot-scope="{ item }">
								<v-text-field v-model="item.prodName" dense hide-details autofocus>
								</v-text-field>
							</template>
							<template slot="item.prodSpec" slot-scope="{ item }">
								<v-text-field v-model="item.prodSpec" dense hide-details autofocus>
								</v-text-field>
							</template>
							<template slot="item.quantity" slot-scope="{ item }">
								<v-text-field v-model="item.quantity" dense hide-details autofocus>
								</v-text-field>
							</template>
							<template slot="item.unit" slot-scope="{ item }">
								<v-text-field v-model="item.unit" dense hide-details autofocus>
								</v-text-field>
							</template>
							<template slot="item.price" slot-scope="{ item }">
								<v-text-field v-model="item.price" dense hide-details autofocus>
								</v-text-field>
							</template>
							<template slot="item.money" slot-scope="{ item }">
								<v-text-field v-model="item.money" dense hide-details autofocus>
								</v-text-field>
							</template>
							<template slot="item.delivered" slot-scope="{ item }">
								<v-text-field v-model="item.delivered" dense hide-details autofocus>
								</v-text-field>
							</template>
							<template slot="item.deliver" slot-scope="{ item }">
								<v-text-field v-model="item.deliver" dense hide-details autofocus>
								</v-text-field>
							</template>
							<template slot="item.purpose" slot-scope="{ item }">
								<v-text-field v-model="item.purpose" dense hide-details autofocus>
								</v-text-field>
							</template>
							<template slot="item.action" slot-scope="{ item }">
								<v-icon small @click="deleteDeliver(item)">
									mdi-delete
								</v-icon>
							</template>
							<template v-slot:footer>
								<v-container>
									<v-row>
										<v-col style="text-align: right;">
											<v-btn color="blue-darken-1" variant="text"
												@click="addDeliverItem">添加</v-btn>
										</v-col>
									</v-row>
									<v-row>
										<v-col cols="12" sm="4">送货方式：<v-radio-group row v-model="logistic.logisticType"
												@change="logisticTypeChange()"><v-radio label="送货上门"
													value="自送">送货上门</v-radio><v-radio label="物流派送"
													value="物流"></v-radio></v-radio-group></v-col>
										<v-col cols="12" sm="4"><v-text-field label="物流公司" v-model="logistic.logisticExpressCompany"
												:disabled="logisticDisable"></v-text-field></v-col>
										<v-col cols="12" sm="4"><v-text-field label="单号" v-model="logistic.logisticSn"
												:disabled="logisticDisable"></v-text-field>
										</v-col>
									</v-row>
								</v-container>
							</template>
						</v-data-table>
					</v-card-text>
					<v-card-actions class="dialog-actions">
						<v-spacer></v-spacer>
						<v-btn color="blue-darken-1" variant="text" @click="saveDeliver">保存送货记录</v-btn>
						<v-btn color="blue-darken-1" variant="text" @click="deliverDialogShow = false;">关闭</v-btn>
						<v-spacer></v-spacer>
					</v-card-actions>
				</v-card>
			</v-dialog>

			<v-dialog v-model="reconciliationDialogOpen" :fullscreen="$vuetify.breakpoint.xsOnly">
				<v-card>
					<v-card-title class="text-h5">对账</v-card-title>
					<v-card-text>
						<v-data-table :items="reconciliations" :headers="reconciliationsHeaders" :item-class="okStatus" class="table-scroll"
							:items-per-page="-1">
							<template slot="item.pucOrderTime" slot-scope="{ item }">
								{{item.pucOrderTime.substring(0, 10)}}
							</template>
							<template slot="item.deliverTime" slot-scope="{ item }">
								{{item.deliverTime.substring(0, 10)}}
							</template>
							<template v-slot:footer>
								<div class="dialog-btn-row" style="padding-top:5px;padding-bottom:5px;text-align:right;">
									<v-btn @click="exportToExcel">导出</v-btn> <v-btn
										@click="reconciliaSure">确认对账单</v-btn>
								</div>
							</template>
						</v-data-table>
						<v-data-table :items="noDelivereds" :headers="cannotReconciliationsHeaders"
							:item-class="noOkStatus" v-if="noDelivereds.length>0" class="table-scroll" :items-per-page="-1">
							<template v-slot:header>
								以下订单不符合对账要求：
							</template>
							<template slot="item.pucOrderTime" slot-scope="{ item }">
								{{item.pucOrderTime.substring(0, 10)}}
							</template>
						</v-data-table>
					</v-card-text>
					<v-card-actions style="text-align: middle;">
						<v-spacer></v-spacer>
						<v-btn @click="reconciliationDialogOpen=false">关闭</v-btn>
						<v-spacer></v-spacer>
					</v-card-actions>
				</v-card>
			</v-dialog>
			<v-dialog v-model="addInvoiceDialogShow" max-width="500">
				<v-card>
					<v-card-title class="text-h5">添加发票信息</v-card-title>
					<v-card-text>
						<v-row>
							<v-col cols="12" sm="4">
								<v-text-field label="发票号" v-model="invoice.sn"></v-text-field>
							</v-col>
							<v-col cols="12" sm="4">
								<v-select label="发票种类" v-model="invoice.type" :items="['普票','专票']"></v-select>
							</v-col>
							<v-col cols="12" sm="4">
								<v-text-field label="发票金额" v-model="invoice.money"></v-text-field>
							</v-col>
						</v-row>
						<v-file-input accept="pdf" label="电子发票" placeholder="上传电子发票" prepend-icon="mdi-camera"
							v-model="file" @change="handleFileUpload" :loading="uploading"></v-file-input>
						<div style="text-align: center;color: chocolate;">{{addInvoiceMsg}}</div>
					</v-card-text>
					<v-card-actions class="dialog-actions">
						<v-btn @click="saveInvoice()">保存</v-btn><v-btn @click="addInvoiceDialogShow=false">关闭</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
		</v-main>
	</v-app>
</template>

<script>
	import NavView from "./../components/NavBar";
	import * as XLSX from 'xlsx';
	import * as pdfjsLib from 'pdfjs-dist';
	pdfjsLib.GlobalWorkerOptions.workerSrc = require('pdfjs-dist/build/pdf.worker.entry.js');
	export default {
		name: 'indexView',
		components: {
			NavView,
		},
		data() {
			return {
				activeTab: 0,
				orderHeaders: [{ text: '序号', value: 'index', mobile: 'index', sortable: false },
                               { text: '订单号', value: 'orderNo', mobile: 'orderNo' },
                               { text: '时间', value: 'cretime', mobile: 'cretime' },
                               { text: '数量', value: 'quantityTotal', mobile: 'quantityTotal' },
                               { text: '金额', value: 'moneyTotal', mobile: 'moneyTotal' },
                               { text: '已到货', value: 'state', mobile: 'state' },
                               { text: '备注', value: 'remarks', mobile: 'remarks' }],
				deliversByUserIdHeaders: [{
						text: '序号',
						value: 'sn',
					}, {
						text: '合同编号',
						value: 'pucOrderNo'
					},
					{
						text: '时间',
						value: 'dateEntered'
					}, {
						text: '送货种类',
						value: 'typeNumber',
					}, {
						text: '送货数量',
						value: 'number',
					},
					{
						text: '送货方式',
						value: 'logisticType',
					},
					{
						text: '物流公司',
						value: 'logisticExpressCompany',
					},
					{
						text: '物流单号',
						value: 'logisticSn',
					}
				],
				orders: [],
				logisticsByUser: [],
				logistics: [],
				logistic: {
					pucOrderId: null,
					logisticType: null,
					logisticExpressCompany: null,
					logisticSn: null
				},
				venderId: null,
				selected: [],
				detailDialog: false,
				details: [],
				// 图纸/文件预览（PDF 用 PDF.js canvas 渲染）
				showImage: false,
				imageUrl: null,
				imgMsg: null,
				showPdf: false,
				pdfLoading: false,
				pdfPageNum: 1,
				pdfTotalPages: 0,
				pdfScale: 1,
				detailHeaders: [{
						text: '时间',
						value: 'dhTime',
					}, {
						text: '品名',
						value: 'prodName',
					},
					{
						text: '规格',
						value: 'prodSpec'
					}, {
						text: '图纸',
						value: 'drawing'
					},
					{
						text: '数量',
						value: "quantity"
					}, {
						text: "单位",
						value: "unit"
					},
					{
						text: "单价",
						value: "price"
					}, {
						text: "总价",
						value: "money"
					}, {
						text: "备注",
						value: 'purpose'
					},
				],
				msgDialog: false,
				msg: null,
				logisticDialog: false,
				selectedLogistic: [],
				deliverDialogShow: false,
				deliverHeaders: [{
						text: '序号',
						value: 'sn',
					},
					{
						text: '品名',
						value: 'prodName',
					}, {
						text: '规格',
						value: 'prodSpec',
					}, {
						text: '备注',
						value: 'purpose',
					},
					{
						text: "单位",
						value: "unit"
					}, {
						text: "单价",
						value: "price"
					},
					{
						text: '数量',
						value: 'quantity',
					},
					{
						text: '已送',
						value: 'delivered',
					},
					{
						text: '送货数量',
						value: 'deliver',
					},
					{
						text: "金额",
						value: "money"
					},
					{
						text: '操作',
						value: 'action',
					}
				],
				delivers: [],
				deliverSelected: [],
				newDeliver: {
					name: null
				},
				editedDeliverItem: null,
				logisticType: "物流",
				logisticDisable: false,
				delivereds: [],
				deliversByUserId: [],
				selectedDeliversByUserId: [],
				selectedReconciliationSaved: [],
				reconciliationsHeaders: [{
						text: "下单日期",
						value: 'pucOrderTime',
					}, {
						text: "送货时间",
						value: 'deliverTime',
					}, {
						text: "到货时间",
						value: "dhTime"
					}, {
						text: "合同号",
						value: 'orderNo',

					}, {
						text: "品名",
						value: "prodName"
					},
					{
						text: "规格",
						value: "prodSpec"
					},
					{
						text: "单位",
						value: "unit"
					},
					{
						text: "单价",
						value: "price"
					},
					{
						text: "数量",
						value: "quantity"
					},
					{
						text: "金额",
						value: "money"
					},
					{
						text: "备注",
						value: "purpose"
					}
				],
				cannotReconciliationsHeaders: [{
						text: "下单日期",
						value: 'cretime',
					}, {
						text: "合同号",
						value: 'orderNo',

					}, {
						text: "品名",
						value: "prodName"
					},
					{
						text: "规格",
						value: "prodSpec"
					},
					{
						text: "单位",
						value: "unit"
					},
					{
						text: "单价",
						value: "price"
					},
					{
						text: "数量",
						value: "quantity"
					},
					{
						text: "金额",
						value: "money"
					},
					{
						text: "备注",
						value: "purpose"
					},
					{
						text: "不能对账原因",
						value: "state"
					}
				],
				reconciliations: [],
				reconciliationDialogOpen: false,
				reconciliationMsg: [],
				noDelivereds: [],
				reconciliationsSaved: [],
				reconciliationsSavedHeader: [{
						text: "对账时间",
						value: "dateEntered"
					},
					{
						text: "送货总数量",
						value: "number"
					},
					{
						text: "送货种类",
						value: "item"
					},
					{
						text: "对账金额",
						value: "money"
					},
					{
						text: "是否确认",
						value: "sure"
					}
				],
				searchParms: {
					year: null,
					month: null
				},
				addInvoiceDialogShow: false,
				invoice: {
					sn: null,
					type: null,
					money: null,
					fileId: null,
					reconcilationId: null
				},
				uploading: false,
				invoices: [],
				selectedInvoice: [],
				invoicesHeader: [{
					text: "SN",
					value: "invoiceId"
				}, {
					text: "时间",
					value: "dateEntered"
				}, {
					text: "金额",
					value: "money"
				}, {
					text: "发票",
					value: "fileId"
				}],
				addInvoiceMsg: null,
				file: null
			}
		},
		created() {

		},
		mounted() {
			this.getOrder();
			this.venderId = localStorage.getItem("venderId");
			if (this.$route.query.tabId != undefined) {
				this.activeTab = parseInt(this.$route.query.tabId);
			}
			switch (this.activeTab) {
				case 1:
					this.getDelivers();
					break;
				case 2:
					this.getReconciliationsSaved();
					break;
				default:
					break;
			}
		},
		methods: {
			getOrder() {
				this.venderId = localStorage.getItem("venderId");
				if (this.venderId != null) {
					this.$axios.post(this.serverYdnUrl + "/apiForKtSupplier/getPucOrderByVenderId", {
						venderId: this.venderId
					}).then(res => {
						if (res.data.data != null) {
							this.orders = res.data.data;
						}
					});
				}
			},
			async getOrdersState() {
				await this.$axios.post(this.serverYdnUrl + "/apiForKtSupplier/getOrders")
			},
			showDetail() {
				this.details = [];
				if (this.selected.length == 1) {
					this.$axios.post(this.serverYdnUrl + "/apiForKtSupplier/getPucOrderDetailByOrderId", {
						orderId: this.selected[0].stringId
					}).then(res => {
						if (res.data.data != null) {
							this.details = res.data.data;
							this.detailDialog = true;
						}
					})
				} else {
					this.msgDialog = true;
					this.msg = "请选择一条记录";
				}
			},
			showLogistic() {
				if (this.selected.length == 1) {
					this.$axios.post(this.serverUrl + "/logistic/getByOrderId", {
						orderId: this.selected[0].stringId
					}).then(res => {
						if (res.data.data != null) {
							this.logistics = res.data.data;
						}
					})
					this.logisticDialog = true;
				} else {
					this.msgDialog = true;
					this.msg = "请选择一条记录";
				}

			},

			//删除多个物流信息
			delLogistics() {
				if (this.selectedLogistic.length > 0) {
					let ids = [];
					this.selectedLogistic.forEach(item => {
						ids.push(item.id);
					})
					this.$axios.post(this.serverUrl + "/logistic/delLogistic", ids).then(res => {
						if (res.data.state == 200) {
							this.getLogisticsByUser();
						}
					})
				} else {
					this.msgDialog = true;
					this.msg = "请选择";
				}
			},
			//删除单个物流信息
			delLogistic(id) {
				let ids = [];
				ids.push(id);
				this.$axios.post(this.serverUrl + "/logistic/delLogistic", ids).then(res => {
					if (res.data.state == 200) {
						this.showLogistic();
					}
				})
			},
			print() {
				if (this.selected.length == 1) {
					this.$axios.post(this.serverYdnUrl + "/apiForKtSupplier/printPucOrder", {
						orderId: this.selected[0].stringId
					}, {
						responseType: 'blob', // 必须指定响应类型
						headers: {
							token: localStorage.getItem("authToken")
						}
					}).then(response => {
						console.log(response);
						// 创建临时 URL
						const blob = new Blob([response.data], {
							type: response.headers['content-type']
						});
						const testUrl = window.URL.createObjectURL(blob);
						window.open(testUrl);
					});
				} else {
					this.msgDialog = true;
					this.msg = "请选择一条记录";
				}
			},
			async deliverDialogOpen() {
				this.delivers = [];
				if (this.selected.length == 1) {
					const res1 = await this.$axios.post(this.serverYdnUrl +
						"/apiForKtSupplier/getPucOrderDetailByOrderId", {
							orderId: this.selected[0].stringId
						});

					if (res1.data.data != null) {
						this.delivers = res1.data.data;
						const res2 = await this.$axios.post(this.serverUrl + "/order/getDelivers", {
							orderId: this.selected[0].stringId
						});
						let i = 0;

						if (res2.data.data.length > 0) {
							//存在送货记录
							this.delivereds = res2.data.data;
							this.delivers.forEach(item => {
								item.delivered = 0;
								this.delivereds.forEach(deliver => {
									if (deliver.pucOrderDetailId == item
										.pucOrderDetailId) {
										if (deliver.number == null) {
											deliver.number = 0;
										}
										item.delivered = item.delivered + deliver.number;
									}
								})
								this.delivers[i].sn = i + 1;
								this.delivers[i].delivered = item.delivered;
								this.delivers[i].deliver = item.quantity - item.delivered;
								this.delivers[i].money = (item.quantity - item.delivered) * item.price;
								i = i + 1;
							})
						} else {
							this.delivers.forEach(item => {
								this.delivers[i].sn = i + 1;
								this.delivers[i].deliver = item.quantity;
								this.delivers[i].money = item.quantity * item.price;
								i = i + 1;
							})
						}
					}
					this.deliverDialogShow = true;
				} else {
					this.msgDialog = true;
					this.msg = "请选择一条记录";
				}

			},
			editItemDeliver(item) {
				this.editedDeliverItem = item;
			},
			deleteDeliver(item) {
				// 找到要删除项的索引
				const index = this.delivers.findIndex(d => d.sn === item.sn);

				if (index !== -1) {
					// 使用 splice 删除该项
					this.delivers.splice(index, 1);
					let i = 0;
					this.delivers.forEach(() => {
						this.delivers[i].sn = i + 1;
						i++;
					})
				}
			},
			saveDeliver() {
				let check = true;
				let checkMsg = "";
				this.delivers.forEach(item => {
					item.pucOrderId = this.selected[0].stringId;
					if (item.deliver == 0 || item.deliver == null) {
						check = false;
						checkMsg = "序号：" + item.sn + "，送货数量为0或未填，可从送货清单中删除！";
					} else if (item.deliver < 0) {
						check = false;
						checkMsg = "序号：" + item.sn + "，送货数量不能小于0！";
					} else if ((parseInt(item.deliver) + item.delivered) > item.quantity) {
						console.log(item);
						check = false;
						checkMsg = "序号：" + item.sn + "，累计送货超出订单总量";
					} else if (item.deliver * item.price != item.money) {
						check = false;
						checkMsg = "序号：" + item.sn + "，金额不等于数量乘以单价";
					}
				});

				if (this.logistic.logisticType == null) {
					check = false;
					checkMsg = "送货方式未选";
				} else {
					if (this.logistic.logisticType == "物流" && (this.logistic.logisticExpressCompany == null || this
							.logistic.logisticSn == null)) {
						check = false;
						checkMsg = "需要输入完整的物流信息";
					}
				}
				if (!check) {
					this.msgDialog = true;
					this.msg = checkMsg;
				}

				if (check) {
					this.$axios.post(this.serverUrl + "/order/addDeliver", {
						delivers: this.delivers,
						logistic: this.logistic,
						pucOrderId: this.selected[0].stringId,
						pucOrderNo: this.selected[0].orderNo,
						venderId: this.venderId
					}).then(res => {
						if (res.data.state == 200) {
							this.delivers = [];
							this.logistic.pucOrderId = null;
							this.logistic.logisticType = null;
							this.logistic.logisticExpressCompany = null;
							this.logistic.logisticSn = null;
							this.deliverDialogShow = false;
						}
					})
				}
			},
			logisticTypeChange() {
				if (this.logistic.logisticType == "物流") {
					this.logisticDisable = false;
				} else {
					this.logisticDisable = true;
				}
			},
			async getDelivers() {
				const res = await this.$axios.post(this.serverUrl + "/order/getDeliversByUserId");
				if (res.data.data.length > 0) {
					this.deliversByUserId = res.data.data;
					let i = 0;
					this.deliversByUserId.forEach(() => {
						this.deliversByUserId[i].sn = i + 1;
						i = i + 1;
					})
				} else {
					this.deliversByUserId = [];
				}
			},
			printDeliver() {
				if (this.selectedDeliversByUserId.length == 1) {
					this.$axios.post(this.serverUrl + "/logistic/deliverPrint", {
						deliverId: this.selectedDeliversByUserId[0].deliverId
					}, {
						responseType: 'blob', // 必须指定响应类型
						headers: {
							token: localStorage.getItem("authToken")
						}
					}).then(response => {
						// 创建临时 URL
						const blob = new Blob([response.data], {
							type: response.headers['content-type']
						});
						const testUrl = window.URL.createObjectURL(blob);
						window.open(testUrl);
					});
				} else {
					this.msgDialog = true;
					this.msg = "请选择一条记录";
				}
			},
			delDeliverIndeliversByUserId() {
				if (this.selectedDeliversByUserId.length == 1) {
					this.$axios.post(this.serverUrl + "/logistic/deleteDeliver", {
						deliverId: this.selectedDeliversByUserId[0].deliverId
					}, {
						headers: {
							token: localStorage.getItem("authToken")
						}
					}).then(response => {
						if (response.data.state == 200) {
							this.getDelivers();
							this.selectedDeliversByUserId = [];
						} else {
							this.msgDialog = true;
							this.msg = "删除失败，联系系统管理员";
						}
					});
				} else {
					this.msgDialog = true;
					this.msg = "请选择一条记录";
				}
			},
			addDeliverItem() {
				this.delivers.push({
					sn: this.delivers.length + 1,
				});
			},
			reconciliation() {
				this.reconciliations = [];
				this.noDelivereds = [];
				if (this.selected.length > 0) {
					this.reconciliationDialogOpen = true;
					this.selected.forEach(item => {
						this.$axios.post(this.serverUrl + "/logistic/reconciliation", item).then(res => {
							if (res.data.state == 200) {
								res.data.data.toReconcilation.forEach(item => {
									item.pucOrderTime = item.cretime;
									this.reconciliations.push(item);
								})
								res.data.data.cannotToReconcilation.forEach(item => {
									item.pucOrderTime = item.cretime;
									this.noDelivereds.push(item);
								})
								//console.log(this.reconciliations);
							} else {
								this.msgDialog = true;
								this.msg = "系统出错，请联系系统管理员";
							}
						})
					})
				} else {
					this.msgDialog = true;
					this.msg = "请选择订单进行对账";
				}
			},
			okStatus() {
				// 根据条件返回不同的 CSS 类
				return 'green-bg';
			},
			noOkStatus() {
				return 'red-bg';
			},
			exportToExcel() {
				// 准备数据
				const data = this.reconciliations.map(item => {
					return {
						'送货时间': item.dateEntered,
						'合同号': item.pucOrderNo,
						'品名': item.prodName,
						'规格': item.prodSpec,
						'数量': item.number,
						'单位': item.unit,
						'单价': item.price,
						'金额': item.money,
						'备注': item.purpose
					};
				});


				// 创建工作簿
				const wb = XLSX.utils.book_new();
				const ws = XLSX.utils.json_to_sheet(data);

				// 将工作表添加到工作簿
				XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

				// 导出文件
				XLSX.writeFile(wb, "对账单.xlsx");
			},
			reconciliaSure() {

				this.$axios.post(this.serverUrl + "/logistic/reconciliaSure", this.reconciliations).then(res => {
					if (res.data.state == 200) {
						this.reconciliations = [];
						this.reconciliationDialogOpen = false;
					}
				})
			},
			reconciliaSureAndPrint() {

			},
			getReconciliationsSaved() {
				this.$axios.post(this.serverUrl + "/logistic/getReconciliations").then(res => {
					if (res.data.state == 200) {
						this.reconciliationsSaved = res.data.data;
						this.selectedReconciliationSaved = [];
					}
				})
			},
			search() {
				this.venderId = localStorage.getItem("venderId");
				if (this.venderId != null) {
					this.$axios.post(this.serverYdnUrl + "/apiForKtSupplier/getPucOrderByVenderId", {
						venderId: this.venderId,
						year: this.searchParms.year,
						month: this.searchParms.month
					}).then(res => {
						if (res.data.data != null) {
							this.orders = res.data.data;
						}
					});
				}
			},
			deleteReconciliation() {
				if (this.selectedReconciliationSaved.length > 0) {
					let check = true;
					this.selectedReconciliationSaved.forEach(item => {
						if (item.sure == 1) {
							check = false;
						}
					})
					if (check) {
						this.$axios.post(this.serverUrl + "/logistic/deleteReconciliations", this
								.selectedReconciliationSaved)
							.then(res => {
								if (res.data.state == 200) {
									this.getReconciliationsSaved();
								}
							})
					} else {
						this.msgDialog = true;
						this.msg = "存在已确认的对账，已确认的对账单不能删除。";
					}
				} else {
					this.msgDialog = true;
					this.msg = "请选择对账单";
				}
			},
			printReconciliation() {
				if (this.selectedReconciliationSaved.length == 1) {
					this.$axios.post(this.serverUrl + "/logistic/printReconciliation", this.selectedReconciliationSaved, {
							responseType: 'blob', // 必须指定响应类型
							headers: {
								token: localStorage.getItem("authToken")
							}
						})
						.then(res => {
							const blob = new Blob([res.data], {
								type: res.headers['content-type']
							});
							const testUrl = window.URL.createObjectURL(blob);
							window.open(testUrl);

						})
				} else {
					this.msgDialog = true;
					this.msg = "请选择一张对账单";
				}
			},
			addInvoice() {
				if (this.selectedReconciliationSaved.length == 1) {
					if (this.selectedReconciliationSaved[0].sure == 1) {
						this.file = null;
						this.addInvoiceDialogShow = true;
						this.invoice.money = this.selectedReconciliationSaved[0].money;
						this.addInvoiceMsg = null;
					} else {
						this.msgDialog = true;
						this.msg = "未确认的对账单不能添加发票";
					}
				} else {
					this.msgDialog = true;
					this.msg = "请选择单张对账单";
				}
			},
			async handleFileUpload(file) {
				if (!file) return;

				this.uploading = true;

				const formData = new FormData();
				formData.append('file', file);

				try {
					const response = await this.$axios.post(this.serverUrl + '/file/upload', formData, {
						headers: {
							'Content-Type': 'multipart/form-data'
						}
					});
					if (response.data.state == 200) {
						this.invoice.fileId = response.data.data;
					}

					// 处理上传成功后的逻辑
				} catch (error) {
					console.error('上传失败:', error);
					// 处理错误
				} finally {
					this.uploading = false;
				}
			},
			saveInvoice() {
				this.invoice.reconcilationId = this.selectedReconciliationSaved[0].reconcilationId;
				this.$axios.post(this.serverUrl + '/invoice/addInvoice', this.invoice).then(
					res => {
						if (res.data.state == 200) {
							this.addInvoiceDialogShow = false;
							this.invoice.fileId = null;
							this.invoice.money = null;
							this.invoice.sn = null;
							this.invoice.type = null;
							this.getInvicesByVender();
						} else {
							this.addInvoiceMsg = res.data.msg;
						}
					});

			},
			getInvicesByVender() {
				this.$axios.post(this.serverUrl + '/invoice/getInvoiceByVender').then(res => {
					if (res.data.state == 200 && res.data.data != null) {
						this.invoices = res.data.data;
					}
				})
			},
			getInvoiceFile(fileId) {
				this.loading = true;
				this.error = null;
				this.imgMsg = null;
				this.imageUrl = null;
				this.closePdf();
				this.$axios.post(this.serverUrl + "/file/getFile", {
						fileId: fileId
					}, {
						responseType: 'blob', // 必须指定响应类型
						headers: {
							token: localStorage.getItem("authToken")
						}
					})
					.then(res => {
						this.previewByContentType(res);
					})
					.catch(error => {
						if (error.response && error.response.status === 404) {
							this.imageUrl = null;
							this.imgMsg = "文件丢失";
							this.showImage = true;
						}
					})
			},
			deleteInvoice() {
				if (this.selectedInvoice.length == 1) {
					this.$axios.post(this.serverUrl + '/invoice/del', this.selectedInvoice[0]).then(res => {
						if (res.data.state == 200) {
							this.selectedInvoice = [];
							this.getInvicesByVender();
						}
					})
				} else {
					this.msgDialog = true;
					this.msg = "请选择单张发票";
				}
			},
			// 统一预览：按 content-type 分流（PDF → PDF.js；图片 → img；其他 → 提示）
			previewByContentType(response) {
				let contentType = (response.headers['content-type'] || '').toLowerCase();
				const blob = new Blob([response.data], {
					type: contentType
				});
				if (contentType.indexOf('application/pdf') >= 0) {
					// PDF 档：PDF.js canvas 渲染（全端兼容，不依赖浏览器内嵌查看器）
					this.renderPdf(blob);
				} else if (contentType.indexOf('image/') === 0) {
					// 图片：img 预览
					this.imageUrl = URL.createObjectURL(blob);
					this.imgMsg = null;
					this.showImage = true;
				} else {
					this.imgMsg = "不支持的文件类型";
					this.showImage = true;
				}
			},
			fetchImage(findFileId) {
				this.loading = true;
				this.error = null;
				this.imgMsg = null;
				this.imageUrl = null;
				this.closePdf();
				// POST 请求示例（发送过滤参数）
				this.$axios.post(this.serverUrl + "/file/getFileFromYdn", {
					filters: {
						// width: 300,
						// height: 200,
						grayscale: true
					},
					fileId: findFileId
				}, {
					responseType: 'blob', // 必须指定响应类型
					headers: {
						token: localStorage.getItem("authToken")
					}
				}).then(response => {
					this.previewByContentType(response);
				}).catch(error => {
					if (error.response) {
						// 服务器返回了错误状态码（如 404）
						if (error.response.status === 404) {
							this.imageUrl = null;
							this.imgMsg = "图片丢失";
							this.showImage = true;
						}
					}
				});
			},
			viewDrawing(item) {
				if (item.drawing && item.drawing != 'null') {
					let files = JSON.parse(item.drawing);
					if (files.length > 0) {
						this.fetchImage(files[0]);
					}
				}
			},
			// ===== PDF.js 渲染（移动端/桌面统一） =====
			async renderPdf(blob) {
				this.showPdf = true;
				this.pdfLoading = true;
				this.pdfPageNum = 1;
				this.pdfTotalPages = 0;
				this.pdfScale = 1;
				this.showImage = true;
				try {
					const buf = await blob.arrayBuffer();
					this.pdfDoc = await pdfjsLib.getDocument({ data: buf }).promise;
					this.pdfTotalPages = this.pdfDoc.numPages;
					await this.$nextTick();
					await this.pdfRenderPage();
				} catch (e) {
					console.error('PDF 渲染失败', e);
					this.imgMsg = "PDF 加载失败";
				} finally {
					this.pdfLoading = false;
				}
			},
			async pdfRenderPage() {
				if (!this.pdfDoc) return;
				const canvas = this.$refs.pdfCanvas;
				if (!canvas) return;
				const page = await this.pdfDoc.getPage(this.pdfPageNum);
				const baseViewport = page.getViewport({ scale: this.pdfScale });
				// 适配屏幕宽度（首屏自动适配，缩放后按用户比例）
				const container = this.$refs.pdfScroll;
				let scale = this.pdfScale;
				if (container && this.pdfScale === 1) {
					const fitScale = (container.clientWidth - 8) / baseViewport.width;
					scale = Math.min(1, Math.max(0.2, fitScale));
				}
				const viewport = page.getViewport({ scale });
				const dpr = window.devicePixelRatio || 1;
				canvas.width = Math.floor(viewport.width * dpr);
				canvas.height = Math.floor(viewport.height * dpr);
				canvas.style.width = Math.floor(viewport.width) + 'px';
				canvas.style.height = Math.floor(viewport.height) + 'px';
				const ctx = canvas.getContext('2d');
				ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
				await page.render({ canvasContext: ctx, viewport }).promise;
			},
			pdfPrevPage() {
				if (this.pdfPageNum > 1) {
					this.pdfPageNum--;
					this.pdfRenderPage();
				}
			},
			pdfNextPage() {
				if (this.pdfPageNum < this.pdfTotalPages) {
					this.pdfPageNum++;
					this.pdfRenderPage();
				}
			},
			pdfZoomIn() {
				if (this.pdfScale < 4) {
					this.pdfScale = Math.round((this.pdfScale * 1.25) * 100) / 100;
					this.pdfRenderPage();
				}
			},
			pdfZoomOut() {
				if (this.pdfScale > 0.2) {
					this.pdfScale = Math.round((this.pdfScale / 1.25) * 100) / 100;
					this.pdfRenderPage();
				}
			},
			closePdf() {
				if (this.pdfDoc) {
					try { this.pdfDoc.destroy(); } catch (e) { console.warn(e); }
					this.pdfDoc = null;
				}
				this.showPdf = false;
				this.pdfLoading = false;
				this.pdfTotalPages = 0;
				this.pdfPageNum = 1;
				this.pdfScale = 1;
			},
			closeImage() {
				if (this.imageUrl) {
					URL.revokeObjectURL(this.imageUrl);
				}
				this.imageUrl = null;
				this.imgMsg = null;
				this.closePdf();
				this.showImage = false;
			},
		}
	}
</script>

<style>
	.custom-list .v-list-item {
		list-style-type: disc;
		/* 圆点符号 */
		list-style-position: inside;
		/* 符号位置 */
	}

	.green-bg {
		background-color: #e8f5e9;
		/* 浅绿色 */
	}

	.action-bar {
		display: inline-flex;
		flex-wrap: wrap;
		gap: 8px;
		margin: 10px;
	}

	.dialog-btn-row {
		display: flex;
		flex-wrap: wrap;
		justify-content: flex-end;
		gap: 8px;
	}

	@media (max-width: 599px) {
		.action-bar {
			display: flex;
			flex-direction: row;
			flex-wrap: nowrap;
			gap: 8px;
			margin: 10px 0;
		}
		.action-bar .v-btn {
			flex: 1 1 0;
			min-width: 0;
			padding: 0 8px;
			margin: 0 !important;
		}
		.dialog-actions .v-btn,
		.dialog-btn-row .v-btn {
			width: 100%;
			margin: 0 !important;
		}
		.table-scroll table {
			min-width: 680px;
		}
	}
</style>